// @ts-strict

import { Component, EventEmitter, Input, Output } from '@angular/core';
import { ITrafficSourceDomain } from '@app/core/services/traffic-sources/traffic-sources.types';
import { NgbModal } from '@ng-bootstrap/ng-bootstrap';
import { AddTrafficSourceModalComponent } from '@app/shared/components/modals/add-traffic-source-modal/add-traffic-source-modal.component';
import { TrafficSourcesService } from '@services/traffic-sources/traffic-sources.service';
@Component({
  selector: 'app-traffic-source',
  templateUrl: './traffic-source.component.html',
  styleUrls: ['./traffic-source.component.scss']
})
export class TrafficSourceComponent {
  @Input() submitted: boolean = false;
  @Output() emitSelectedDomain = new EventEmitter<number>();

  @Output() emitAddNewTrafficSource = new EventEmitter<void>();

  public selectedDomain?: number;
  @Input() domains: ITrafficSourceDomain[] = [];

  constructor(private trafficSourceService: TrafficSourcesService, private modalService: NgbModal) {}

  public emitDomain(): void {
    this.emitSelectedDomain.emit(this.selectedDomain);
  }

  public changeChevronUp(): void {
    document.getElementsByClassName('ng-arrow-wrapper').item(0)?.classList.add('ng-select-open');
  }
  public changeChevronDown(): void {
    document.getElementsByClassName('ng-arrow-wrapper').item(0)?.classList.remove('ng-select-open');
  }

  public onAddNewTrafficSource(): void {
    this.emitAddNewTrafficSource.emit();
  }
}
